<template>
    <div class="w-full h-screen bg-[#FFF6EF] flex items-center justify-center">
        <router-view />
    </div>
</template>

